<template>
  <div class="feature-row">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
            ><img
              src="../../static/images/common-icons/brand-logos/acura.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
            ><img
              src="../../static/images/common-icons/brand-logos/audi.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/bmw.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/buick.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/cadillac.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/chevy.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/chrysler.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/dodge.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/fiat.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/ford-logo.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/genesis.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/gmc.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/honda.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
            ><img
                src="../../static/images/common-icons/brand-logos/hummer.png"
                class="img-responsive brand-logo"
            /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
            ><img
                src="../../static/images/common-icons/brand-logos/hyundai.png"
                class="img-responsive brand-logo"
            /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/infiniti.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/isuzu.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/jeep.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/kia-logo.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/landrover.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/lexus.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/lincoln.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/mazda.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/mercedes.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/mercury.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/mini.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/mitsubishi.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/nissan.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/ram.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/subaru.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 col-md-offset-3 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/toyota.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/volkswagen.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 col-bump-1 brand-col">
          <a href="#" class="brand-link"
          ><img
              src="../../static/images/common-icons/brand-logos/volvo.png"
              class="img-responsive brand-logo"
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    $("a.brand-link").removeAttr("href");
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.brand-link {
  cursor: pointer;
}

.feature-row {
  background: #fff;
  padding: 60px 0;
}

.brand-logo {
  display: block;
  position: relative;
  max-width: 130px;
  margin: auto;
  padding: 10px 0;
  border-radius: 3px;
  background-color: transparent;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}

.brand-logo:hover,
.brand-logo:focus {
  background-color: #efefef;
}

.brand-logo img {
  margin: auto;
}
.locations-dropdown {
  display: none;
  position: absolute;
  left: 0;
  top: 100%;
  width: 260px;
  list-style: none;
  background-color: #fff;
  margin: 0;
  padding: 5px 0 10px;
  z-index: 1;
  box-shadow: 0 10px 35px 5px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 10px 35px 5px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 10px 35px 5px rgba(0, 0, 0, 0.2);
}
.brand-logo.dropdown-toggle:hover:before,
.brand-logo.dropdown-toggle:focus:before {
  content: " ";
  z-index: 2;
  position: absolute;
  bottom: 0px;
  left: 50%;
  margin-left: -14px;
  border-style: solid;
  border-width: 0 14px 14px;
  border-color: #fff transparent;
}
.brand-logo:hover > .locations-dropdown,
.brand-logo:focus > .locations-dropdown {
  display: block;
}

.locations-dropdown a {
  display: block;
  text-decoration: none;
  padding: 5px 15px;
}
.locations-dropdown address,
.locations-dropdown p {
  color: #2c3e50;
  margin-bottom: 10px;
}

.locations-dropdown button {
  padding: 5px 15px;
  color: #fff;
  outline: none;
  border: none;
  border-radius: 3px;
  background-color: #f57c00;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
  transition: background 0.3s ease;
  -webkit-transition: background 0.3s ease;
}

.locations-dropdown button:hover {
  background-color: #3884c7;
}
@media (max-width: 991px) {
  .brand-logo {
    max-width: 100px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .brand-col:nth-of-type(3n + 2) .locations-dropdown {
    left: -90px;
  }
  .brand-col:nth-of-type(3n) .locations-dropdown {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .brand-col:nth-of-type(4n) .locations-dropdown {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .brand-col:nth-of-type(6n) .locations-dropdown {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) and (max-width: 1500px) {
  .brand-logo img img {
    width: 12.2vw;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .col-bump-1 {
    margin-left: 36%;
  }
}
@media (max-width: 767px) {
  .col-bump-2 {
    margin-left: 33%;
  }
}
</style>
